.container {
  container-type: inline-size;
}

.row {
  display: grid;
  grid-template-areas: 'host identity players action';
  grid-template-columns: auto 1fr 72px 168px;
  align-items: center;
  gap: var(--zumpo-space-16);
  padding: var(--zumpo-space-20);
  border: 1px solid var(--zumpo-line);
  border-radius: var(--zumpo-radius-16);
  background: var(--zumpo-paper);
  color: var(--zumpo-ink);
}

.host {
  grid-area: host;
}

.identity {
  display: flex;
  flex-direction: column;
  grid-area: identity;
  gap: var(--zumpo-space-4);
  min-width: 0;
}

.name {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-6);
  min-width: 0;
  margin: 0;
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

.nameText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lock {
  flex: none;
}

.details {
  overflow: hidden;
  color: var(--zumpo-muted);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.players {
  display: flex;
  grid-area: players;
  align-items: center;
  gap: var(--zumpo-space-6);
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
  white-space: nowrap;
}

.players svg {
  color: var(--zumpo-muted);
}

/*
 * As tall as the Join button whatever it holds, so every status is the same
 * height, and as wide as Playing beside Watch, the widest it holds, so the
 * counts of a list line up. A room you can only watch keeps its state beside
 * Watch.
 */
.action {
  display: flex;
  flex-wrap: wrap;
  grid-area: action;
  align-items: center;
  justify-content: flex-end;
  gap: var(--zumpo-space-8);
  min-height: 48px;
}

/* Phone: the player count moves under the details. */
@container (max-width: 560px) {
  .row {
    grid-template-areas:
      'host identity action'
      'host players action';
    grid-template-columns: auto 1fr minmax(72px, auto);
    column-gap: var(--zumpo-space-12);
    row-gap: var(--zumpo-space-4);
    padding: var(--zumpo-space-16);
  }

  .identity {
    align-self: end;
  }

  .players {
    align-self: start;
  }
}
